import _objectWithoutProperties from "/source/HikariRec/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/source/HikariRec/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import classNames from 'classnames';
import * as React from 'react';
import { useMemo } from 'react';
import createWithBsPrefix from './createWithBsPrefix';
import { useBootstrapPrefix } from './ThemeProvider';
import FormCheckInput from './FormCheckInput';
import InputGroupContext from './InputGroupContext';
import { jsx as _jsx } from "react/jsx-runtime";
var InputGroupText = createWithBsPrefix('input-group-text', {
  Component: 'span'
});
var InputGroupCheckbox = function InputGroupCheckbox(props) {
  return /*#__PURE__*/_jsx(InputGroupText, {
    children: /*#__PURE__*/_jsx(FormCheckInput, _objectSpread({
      type: "checkbox"
    }, props))
  });
};
var InputGroupRadio = function InputGroupRadio(props) {
  return /*#__PURE__*/_jsx(InputGroupText, {
    children: /*#__PURE__*/_jsx(FormCheckInput, _objectSpread({
      type: "radio"
    }, props))
  });
};
var InputGroup = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    size = _ref.size,
    hasValidation = _ref.hasValidation,
    className = _ref.className,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "size", "hasValidation", "className", "as"]);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'input-group');

  // Intentionally an empty object. Used in detecting if a dropdown
  // exists under an input group.
  var contextValue = useMemo(function () {
    return {};
  }, []);
  return /*#__PURE__*/_jsx(InputGroupContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/_jsx(Component, _objectSpread({
      ref: ref
    }, props, {
      className: classNames(className, bsPrefix, size && "".concat(bsPrefix, "-").concat(size), hasValidation && 'has-validation')
    }))
  });
});
InputGroup.displayName = 'InputGroup';
export default Object.assign(InputGroup, {
  Text: InputGroupText,
  Radio: InputGroupRadio,
  Checkbox: InputGroupCheckbox
});